import { render, staticRenderFns } from "./StreamPlatformForm.vue?vue&type=template&id=74319594&scoped=true&"
import script from "./StreamPlatformForm.vue?vue&type=script&lang=js&"
export * from "./StreamPlatformForm.vue?vue&type=script&lang=js&"
import style0 from "./StreamPlatformForm.vue?vue&type=style&index=0&id=74319594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74319594",
  null
  
)

export default component.exports